<template>
  	<div>
    	<breadcrumb :items="breadcrumbs"></breadcrumb>
      <v-container fluid>
            <div class="d-flex mb-4">
                <h2>{{ $t("Enquiries") }}</h2>
                <v-spacer></v-spacer>
                <template>
                    <div>
                        <v-btn 
                            color="primary"
                            dark 
                            depressed
                            @click="$router.push({name: 'CreateEnquiry'})"
                        >
                        CREATE A NEW ENQUIRY
                        </v-btn>
                    </div>
                </template>
            </div>
              <v-card v-if="totalEnquiries> 0 && enquiries.length > 0" elevation="0" class="pa-5">
                <v-data-table
                  :items="enquiries"
                  hide-default-header
                  hide-default-footer
                  :items-per-page="5"
                  :loading="loading"
                  :options.sync="options"
                  :server-items-length="totalEnquiries"
                  :loading-text="$t('loadingData')"
                >
                  <template v-slot:top>
                    <div class="d-flex">
                      <v-toolbar flat>
                        <v-text-field
                          prepend-inner-icon="mdi-magnify"
                          :label="$t('search')"
                          v-model="search"
                          @input="resetSearchOnEmpty"
                          outlined
                          dense
                          hide-details
                          style="max-width: 200px;"
                        ></v-text-field>
                        <v-spacer></v-spacer>
                        <div class="pl-4 title">
                          {{ from }} - {{ to }} of {{ totalEnquiries }}
                        </div>
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          outlined
                          color="primary"
                          :disabled="options.page <= 1"
                          @click="pageChange(false)"
                        >
                          <v-icon dark> mdi-chevron-left </v-icon>
                        </v-btn>
                        <v-btn
                          class="mx-2"
                          fab
                          small
                          outlined
                          color="primary"
                          :disabled="options.page >= totalPages"
                          @click="pageChange(true)"
                        >
                          <v-icon dark> mdi-chevron-right </v-icon>
                        </v-btn>
                      </v-toolbar>
                    </div>
                  </template>
        
                  <template v-slot:body="{ items }">
                    <v-card
                      :class="{ 'odd-row': (index + 1) % 2 !== 0 }"
                      class="elevation-1 mb-4 px-2 ticket-row"
                      v-for="(item, index) in items"
                      :key="index"
                      @click="$router.push({name: 'EnquiriesChat', params: {id: item.id}})"
                    >
                    <div class="d-flex justify-space-between">
                      <v-card-title class="font-weight-bold"> {{ item.subject}}</v-card-title>
                      <v-menu
                        left
                        offset-y
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn icon
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-icon>mdi-dots-vertical</v-icon>
                          </v-btn>
                        </template>
        
                        <v-list color="black">
                          <v-list-item @click="alert(1)">
                            <v-list-item-title class="white--text">Mark as Resolved</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="alert(1)">
                            <v-list-item-title  class="white--text">Re-open the Enquiry</v-list-item-title>
                          </v-list-item>
                          <v-list-item @click="alert(1)">
                            <v-list-item-title  class="white--text">Delete Enquiry</v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </div>
                    <v-divider></v-divider>
                    <v-card-text class="black--text">
                      <v-row>
                        <v-col cols="3">
                          <p class="caption">Area of Enquiry</p>
                          <div class="subtitle-1 mt-n2">{{ item.areaOfRequest}}</div>
                        </v-col>
                        <v-col cols="2">
                          <p class="caption">Type</p>
                          <div class="subtitle-1 mt-n2">{{ item.type}}</div>
                        </v-col>
                        <v-col cols="2">
                          <p class="caption">Status</p>
                          <div class="subtitle-1 mt-n2">{{ item.status}}</div>
                        </v-col>
                        <v-col cols="2">
                          <p class="caption">Attachments</p>
                          <div class="subtitle-1 mt-n2">...{{ item.ticketMedia[0].profilePicS3Key.slice(-10)}}</div>
                        </v-col>
                        <v-col cols="3">
                          <p class="caption">Date</p>
                          <div class="subtitle-1 mt-n2">{{ item.createdAt}}</div>
                        </v-col>
                        <v-col cols="12">
                          <p class="caption">Description</p>
                          <div class="subtitle-1 mt-n2">{{ item.description}}</div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                    </v-card>
                  </template>
                </v-data-table>
              </v-card>
            <v-card flat v-else-if="totalEnquiries== 0 && enquiries.length == 0 && !loading">
              <div class="text-center">
                      <v-row justify="center" align="center">
                        <v-col cols="12" sm="4">
                          <div class="py-16">
                            <img src="/img/Notes.svg" /><br />
                            <strong>No ENQUIRY</strong><br />
                            <div class="py-4">
                              <small>
                                You have not submitted any enquires yet. <br/>
                                Click on "Create a New Enquiry" button to <br/>
                                submit your question</small
                              >
                            </div>
                            <v-btn
                              color="primary"
                              dark
                              @click="$router.push({ name: 'CreateEnquiry' })"
                            >
                              {{ $t("CREATE A NEW ENQUIRY") }}
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </div>
            </v-card>
            <v-card v-else min-height="300" flat>
        
            </v-card>
        </v-container>
  </div>
</template>

<script>
import EnquiryService from "@/_services/EnquiryService";


export default {
    async mounted() {
      const fetch = async() => {
        await this.getEnquiries();
      }
      await fetch();
    },
    watch: {
      options: {
        handler() {
          this.getEnquiries();
        },
        deep: true,
      },
    },
  	data() {
    	return {
        loading: false,
        options: {},
        totalEnquiries: 0,
        enquiries: [],
        search: '',
        from: 0,
        to: 0,
        totalPages: 1,
        breadcrumbs: [
            {
                text: this.$t('dashboard'),
                disabled: false,
                to: "/",
            },
            {
                text: this.$t('Enquiries'),
                disabled: true,
                href: "breadcrumbs_link_1",
            },
        ],
      };
    },

    methods: {
      async getEnquiries() {
        this.loading = true;
        const d =  await EnquiryService.getEnquiries(this.options, this.search);
        this.totalEnquiries = d.enquiriesCount;
        this.enquiries = d.enquiry;
        this.totalPages = Math.ceil(
          this.totalEnquiries / this.options.itemsPerPage
        );
        this.from = (this.options.page - 1) * this.options.itemsPerPage + 1;
        this.to =
          this.options.page * this.options.itemsPerPage -
          (this.options.itemsPerPage - this.enquiries.length);
        this.loading = false;
      },

      resetSearchOnEmpty() {
        this.options.page = 1;
        this.getEnquiries();
      },

      pageChange(t) {
        if (t) {
          this.options.page = this.options.page + 1;
          return;
        } else {
          this.options.page = this.options.page - 1;
          return;
        }
      },
    }

}
</script>
<style lang="scss" scoped></style>
